"use client";

import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

interface PrivacyGuardProps {
    children: React.ReactNode;
}

const PrivacyGuard: React.FC<PrivacyGuardProps> = ({ children }) => {
    const { isLoggedIn, currentUser } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Ha bejelentkezve van, ellenőrizzük az adatvédelmi szabályzat elfogadásáz
        if (
            isLoggedIn &&
            currentUser &&
            location.pathname !== "/privacy"
        ) {
            const privacyNotAccepted = !currentUser.privacy_accepted;

            // Ha nincs elfogadva az adatvédelmi forma
            if (privacyNotAccepted) {
                navigate("/privacy", { replace: true });
            }
        }
    }, [isLoggedIn, currentUser, location.pathname, navigate]);

    return <>{children}</>;
};

export default PrivacyGuard;
